{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Aktivert",
      "DISABLED": "Deaktivert"
    },
    "CONFIGURE": "Konfigurer",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Er du sikker på at du vil slette?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ja, slett",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Inbox",
      "EDIT": {
        "BUTTON_TEXT": "Rediger"
      },
      "DELETE": {
        "BUTTON_TEXT": "Slett"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Opprett",
        "CANCEL": "Avbryt"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
      }
    },
    "EDIT": {
      "TITLE": "Rediger {name}",
      "FORM": {
        "SUBMIT": "Oppdater",
        "CANCEL": "Avbryt"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrasjonshooken ble oppdatert",
        "ERROR_MESSAGE": "Kunne ikke koble til chatserveren, prøv igjen senere"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Koble til"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Synkroniser e-poster og nettchatter til daktela-kontoen din.",
      "RETINO": "Retino skaper orden i retur- og reklamasjonshåndtering.",
      "MAILSHIP": "Mailship er et system for lager- og ordrehåndtering. Slå opp ordrestatus, sporing og forsendelsesdetaljer.",
      "RAYNET": "Koble til Raynet CRM-kontoen din for å få tilgang til kundedataene dine. Legg til en tilkobling med Raynet-brukernavnet og API-tokenet ditt."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Test tilkobling",
      "SUCCESS": "Tilkobling vellykket",
      "ERROR": "Tilkobling mislyktes. Vennligst sjekk påloggingsinformasjonen din."
    }
  }
}
